import AreaChart, { AreaChartBlock } from './components/AreaChart';
import LineChart, { LineChartBlock } from './components/LineChart';
import PieChart, { PieChartBlock } from './components/PieChart';
import HeatMapChart, { HeatMapChartBlock } from './components/HeatMapChart';
import CircularGaugeChart, { CircularGaugeChartBlock } from './components/CircularGaugeChart';

export default (editor, opts = {}) => {
  const dc = editor.DomComponents;
  const bm = editor.BlockManager;

  const { types, labels, blocks, labelDrapcodeChartCategory } = opts;

  if (blocks.lineChart) {
    LineChartBlock(bm, labelDrapcodeChartCategory, labels.lineChart, types.lineChart);
    LineChart(dc, labels.lineChart, types.lineChart, opts);
  }
  if (blocks.areaChart) {
    AreaChartBlock(bm, labelDrapcodeChartCategory, labels.areaChart, types.areaChart);
    AreaChart(dc, labels.areaChart, types.areaChart, opts);
  }
  if (blocks.pieChart) {
    PieChartBlock(bm, labelDrapcodeChartCategory, labels.pieChart, types.pieChart);
    PieChart(dc, labels.pieChart, types.pieChart, opts);
  }
  if (blocks.heatMapChart) {
    HeatMapChartBlock(bm, labelDrapcodeChartCategory, labels.heatMapChart, types.heatMapChart);
    HeatMapChart(dc, labels.heatMapChart, types.heatMapChart, opts);
  }

  if (blocks.circularGaugeChart) {
    CircularGaugeChartBlock(
      bm,
      labelDrapcodeChartCategory,
      labels.circularGaugeChart,
      types.circularGaugeChart,
    );
    CircularGaugeChart(dc, labels.circularGaugeChart, types.circularGaugeChart, opts);
  }
};
